module.exports = __webpack_public_path__ + "img/005.0399d020.png";